import { api } from "@cems-eco/core/src/services/api";
import { BaseMonitorBloc } from "./bloc";

export class BoxMonitorBloc extends BaseMonitorBloc {

    searchParams(log: any, equipment_id: any): string {
        const params = {
            search: {
                advanced: {
                    type: log.level,
                    equipment_id
                }
            }
        } as any;
        if (log.start_date && log.end_date) {
            params.search.between = {
                created_at: `${log.start_date} 00:00:00,${log.end_date} 23:59:59`
            }
        }
        return api.getUrl("/log", params);
    }

}

